import clsx from "clsx";
import { useIntl } from "react-intl";
import { CallManagerButton, CallManagerButtonGroup } from "./types";
import PlanMessageModal from "../Modal/PlanMessageModal/PlanMessageModal";
import { useMessageItem } from "../../context/MessageItemContext/MessageItemContext";
import { useSelector } from "react-redux";

export const ActionButton = ({
   icon,
   label,
   onClick,
   isActive,
   disabled,
   isEndCall = false,
   className,
}: CallManagerButton) => {
   const intl = useIntl();
   return (
      <button
         onClick={onClick}
         className={clsx(
            "call-manager__action-button",
            isActive && "call-manager__action-button--active",
            isEndCall && "call-manager__action-button--end-call",
            className,
         )}
         disabled={disabled}
      >
         <div>{icon}</div>
         <span>{intl.formatMessage({ id: label })}</span>
      </button>
   );
};

export const ButtonGroup = ({
   buttons,
   className = "",
   isPhoneCallActions = false,
}: CallManagerButtonGroup) => {
   const { currentProcessStep } = useMessageItem();

   const { activeCasesFolder } = useSelector(({ settings }) => settings);

   return (
      <div className={className}>
         {buttons.map((action) => {
            if (action.label === "callManager.reschedulePhoneCall") {
               return (
                  <PlanMessageModal
                     key={action.label}
                     tags={currentProcessStep.planningData.tags}
                     privateTags={currentProcessStep.planningData.tags_private}
                     messageId={currentProcessStep.planningData.id}
                     start={currentProcessStep.planningData.start_time}
                     duration={+currentProcessStep.planningData?.duration || 0}
                     title={currentProcessStep.planningData.subject}
                     lockDate={currentProcessStep.planningData.is_locked_date}
                     lockedDataAndTime={currentProcessStep.planningData.is_locked}
                     deadlineDate={currentProcessStep.planningData.deadline}
                     activeCasesFolder={activeCasesFolder}
                     isCallManager={true}
                  />
               );
            }

            return (
               <ActionButton
                  key={action.label}
                  {...action}
                  isEndCall={isPhoneCallActions && action.label === "callManager.endPhoneCall"}
               />
            );
         })}
      </div>
   );
};
